var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPermissionLevel3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7593 5.4306L12.7633 3.03064C12.6431 2.98979 12.5143 2.98979 12.3942 3.03064L5.39821 5.4306C5.16032 5.51283 5 5.74145 5 6.00005V12C5 18.5937 12.3358 20.9512 12.4104 20.9748C12.4652 20.9916 12.5218 21 12.5789 21C12.6361 21 12.6927 20.9916 12.7475 20.9748C12.822 20.9514 20.1579 18.594 20.1579 12V6.00005C20.1579 5.74143 19.9977 5.51282 19.7593 5.4306Z",
    fill: "#6FCFB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4235 15.75C14.0793 15.75 15.2213 14.8364 15.2213 13.5335V13.5231C15.2213 12.4849 14.4894 11.8309 13.3838 11.7271V11.7011C14.2818 11.5142 14.9566 10.8965 14.9566 9.96735V9.95697C14.9566 8.79421 13.9548 8 12.4079 8C10.8973 8 9.87473 8.84092 9.76572 10.1075L9.76053 10.1698H11.0063L11.0115 10.1179C11.079 9.47421 11.6189 9.06413 12.4079 9.06413C13.2125 9.06413 13.6693 9.45864 13.6693 10.1335V10.1438C13.6693 10.7979 13.119 11.2651 12.2937 11.2651H11.4372V12.2617H12.3248C13.28 12.2617 13.8613 12.6978 13.8613 13.4868V13.4972C13.8613 14.1772 13.2851 14.6547 12.4183 14.6547C11.541 14.6547 10.9596 14.2135 10.887 13.6062L10.8818 13.5491H9.59961L9.6048 13.6114C9.70862 14.8675 10.7779 15.75 12.4235 15.75Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPermissionLevel3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_permission_level_3.3d5d1299fa579289e79abddfdb7681ce.svg";